import React from 'react';
import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { DefaultActionCard } from './DefaultActionCard';

export const EmailActionCard = ({ action, email }) => {
  const { t } = useTranslation();

  return (
    <DefaultActionCard
      action={action}
      items={[{ header: t('components.cards.actionSummary.emailAddress'), value: email }]}
    />
  );
};

EmailActionCard.propTypes = {
  action: PropTypes.shape({
    status: PropTypes.string,
    reason: PropTypes.string,
    type: PropTypes.string,
    createdDate: PropTypes.string,
  }),
  email: PropTypes.string,
};
